'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Resize handler
//***********************************************************************************
//***********************************************************************************

import { cn_event_handler } from './cn_event_handler';
import { cn_mouse_event } from './cn_mouse_event';
import {
    cn_add,
    cn_cart,
    cn_clone,
    cn_dot,
    cn_mul,
    cn_normal,
    cn_normalize,
    cn_polar,
    cn_sub,
    cnx_add,
    cnx_clone,
    cnx_cross,
    cnx_mul,
    cnx_normalize,
    cnx_sub
} from '../utils/cn_utilities';
import { cn_camera } from './cn_camera';

export class cn_handler_single_resize extends cn_event_handler {
    //*****************************************************************
    /**
     * Constructor
     * @param {number[]} p0 : first point of resize
     * @param {number[]} p1 : second point of resize
     * @param {cn_event_handler} parent
     */
    constructor(p0, p1, parent) {
        super(parent);
        this.p0 = cnx_clone(p0);
        this.p1 = cnx_clone(p1);
        this.normal = [0, 0, 1];
        this._mouseover = false;
        this._active = true;
    }

    //*****************************************************************
    /**
     * Draw the handler
     * @param {cn_camera} camera
     * @returns {string}
     */
    draw(camera) {
        var html = '';

        if (this._mouseover)
            html += camera.draw_line_move_arrow(this.p0, this.p1);

        return html;
    }

    //*****************************************************************
    /**
     * Clear move data
     */
    clear_move() {
        this._mouseover = false;
    }

    /**
     * Manage a passive move. To return 'true' if something of interest under the mouse.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    move(ev) {
        this.clear_move();
        if (!this._active) return false;

        this._mouseover = ev.camera.on_edge_screen(ev.mouse_screen, this.p0, this.p1);
        return this._mouseover;
    }

    /**
     * Manage a grab. To return 'true' if grab is to be managed.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    grab(ev) {
        return this._mouseover;
    }

    /**
     * Manage a drag. Only after a grab that returned true. To return 'true' if drag had an effect.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    drag(ev) {
        if (ev.camera.is_3d())
            ev.move_to_plane(this.p0, this.normal);
        this.call("move", ev.mouse_world);
        return true;
    }
}

